import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomepageComponent } from './homepage.component';
import { CoreModule, FormControlModule } from '@linkdev/shared-library';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ServiceListModule } from '../service-list/service-list.module';

@NgModule({
  declarations: [HomepageComponent],
  imports: [
    CommonModule,
    CoreModule,
    ServiceListModule,
    RouterModule,
    CommonModule,
    CoreModule,
    ModalModule.forRoot(),
    CollapseModule.forRoot(),
    FormControlModule,
    FormsModule,

  ],
  providers: []
})
export class HomepageModule { }
